var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnInit, QueryList } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { AlertifyService } from '../../../services/alertify.service';
import { AccountApiService } from '../../../services/account.api.service';
import { CustomDefaultPlaceCategoryItemEditedStore, CustomDefaultPlaceCategoryStore, } from '../../../stores/hub.calendar.store';
import { LocalStorageService } from '../../../services/localStorageService';
import { PlaceService } from '../../../services/place.service';
import { guid } from '../../../utils/guid';
import { isEmptyObject, isNumber } from '../../../common/extensions';
import { takeUntil } from 'rxjs/operators';
var CustomizePlaceCategoryComponent = /** @class */ (function (_super) {
    __extends(CustomizePlaceCategoryComponent, _super);
    function CustomizePlaceCategoryComponent(formBuilder, activatedRoute, accountApiService, alertify, customDefaultPlaceCategoryStore, customDefaultPlaceCategoryItemEditedStore) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.customDefaultPlaceCategoryStore = customDefaultPlaceCategoryStore;
        _this.customDefaultPlaceCategoryItemEditedStore = customDefaultPlaceCategoryItemEditedStore;
        _this.isUseDefault = true;
        _this.clientPlaceCategories = [];
        _this.blockGooglePlaceCategories = [];
        _this.subCategoriesOfSelected = [];
        _this.selectedItem = null;
        _this.draggable = true;
        _this.editedCategories = [];
        _this.duplicatedCategories = [];
        _this.disabled = false;
        return _this;
    }
    CustomizePlaceCategoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.form = this.formBuilder.group({
            categoryName: [null, []],
        });
        this.loadCustomCategories();
        this.syncCategoryListAreaHeightWithEditorAreaHeight();
        this.customDefaultPlaceCategoryItemEditedStore.customDefaultPlaceCategoryItemEditedCommand
            .pipe(takeUntil(this.isDestroyed))
            .subscribe(function (data) {
            if (isEmptyObject(data))
                return;
            if (data.type === 'deleted') {
                _this.setCategoryRemovedData(data.item);
            }
            else {
                _this.onCategoryTitleEdited(data);
            }
        });
    };
    Object.defineProperty(CustomizePlaceCategoryComponent.prototype, "categoryLocator", {
        get: function () {
            if (!this.selectedItem)
                return '';
            for (var _i = 0, _a = this.clientPlaceCategories; _i < _a.length; _i++) {
                var firstLevel = _a[_i];
                if (firstLevel.id === this.selectedItem.id) {
                    return "<span class=\"primary-color-text\">" + firstLevel.title + "</span>";
                }
                for (var _b = 0, _c = firstLevel.subCategories; _b < _c.length; _b++) {
                    var secondLevel = _c[_b];
                    if (secondLevel.id === this.selectedItem.id) {
                        return "<span>" + firstLevel.title + " > <span class=\"primary-color-text\">" + secondLevel.title + "</span></span>";
                    }
                    for (var _d = 0, _e = secondLevel.subCategories; _d < _e.length; _d++) {
                        var thirdLevel = _e[_d];
                        if (thirdLevel.id === this.selectedItem.id) {
                            return "<span>" + firstLevel.title + " > " + secondLevel.title + " > <span class=\"primary-color-text\">" + thirdLevel.title + "</span></span>";
                        }
                    }
                }
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    CustomizePlaceCategoryComponent.prototype.changeUseDefault = function () {
        var _this = this;
        if (this.isUseDefault) {
            this.accountApiService.setUseDefaultPlaceCategory(this.hubName).subscribe(function () {
                _this.alertify.successfully('Set to use default place categories');
                _this.sendCategoryUpdateFlow();
                _this.updateLocalStorage();
            });
        }
    };
    CustomizePlaceCategoryComponent.prototype.expandCategory = function () { };
    CustomizePlaceCategoryComponent.prototype.removeFirstLevel = function (item) {
        this.clientPlaceCategories = this.clientPlaceCategories.filter(function (x) { return x.id !== item.id; });
    };
    CustomizePlaceCategoryComponent.prototype.onToggle = function (isOpened) {
        this.draggable = !isOpened;
        this.syncCategoryListAreaHeightWithEditorAreaHeight();
    };
    CustomizePlaceCategoryComponent.prototype.syncCategoryListAreaHeightWithEditorAreaHeight = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.editorArea || !_this.categoryListArea)
                return;
            var rect = _this.editorArea.nativeElement.getBoundingClientRect();
            _this.categoryListArea.nativeElement.style.height = rect.height - 16 + "px";
        });
    };
    CustomizePlaceCategoryComponent.prototype.dragEnter = function ($event) {
        if ($event && $event.currentTarget) {
            this.restoreItemStyle();
            $event.currentTarget.style.outline = '2px dashed green';
        }
    };
    CustomizePlaceCategoryComponent.prototype.restoreItemStyle = function () {
        this.accordions.toArray().forEach(function (x) {
            x.nativeElement.style.outline = 'none';
        });
    };
    CustomizePlaceCategoryComponent.prototype.onItemDrop = function (e, targetIndex) {
        var _this = this;
        console.log({ e: e });
        console.log({ targetIndex: targetIndex });
        var dragItemIndex = this.clientPlaceCategories.indexOf(e.dragData);
        console.log({ dragItemIndex: dragItemIndex });
        // swap items
        _a = [
            this.clientPlaceCategories[dragItemIndex],
            this.clientPlaceCategories[targetIndex],
        ], this.clientPlaceCategories[targetIndex] = _a[0], this.clientPlaceCategories[dragItemIndex] = _a[1];
        setTimeout(function () {
            _this.restoreItemStyle();
        });
        var _a;
    };
    CustomizePlaceCategoryComponent.prototype.save = function (event) {
        var _this = this;
        var categoryTitles = [];
        for (var _i = 0, _a = this.clientPlaceCategories; _i < _a.length; _i++) {
            var category = _a[_i];
            category.isEditing = false;
            this.addSameNameCategory(category);
            PlaceService.getAllSubCategoriesWithEachLevelTitles(category, categoryTitles);
        }
        console.log('categoryTitles', categoryTitles);
        // check if any leaf level categories are duplicated
        var duplicatedCategories = [];
        var _loop_1 = function (title) {
            var duplicated = categoryTitles.find(function (x) { return x.split(' > ').last().toLowerCase() === title.split(' > ').last().toLowerCase(); });
            // const duplicated = categoryTitles.find((x) => x.split(' > ').any((y) => title.split(' > ').includes(y)));
            if (duplicated && title !== duplicated) {
                duplicatedCategories.push([title, duplicated]);
            }
        };
        for (var _b = 0, categoryTitles_1 = categoryTitles; _b < categoryTitles_1.length; _b++) {
            var title = categoryTitles_1[_b];
            _loop_1(title);
        }
        // check if there is any duplicated not only leaf level level category
        var duplicates = categoryTitles.filter(function (item, index) { return categoryTitles.indexOf(item) !== index; });
        if (duplicates.length) {
            for (var _c = 0, duplicates_1 = duplicates; _c < duplicates_1.length; _c++) {
                var d = duplicates_1[_c];
                duplicatedCategories.push([d]);
            }
        }
        console.log('duplicatedCategories', duplicatedCategories);
        if (duplicatedCategories.length) {
            this.duplicatedCategories = duplicatedCategories;
            event.immediateComplete();
            return;
        }
        this.duplicatedCategories = [];
        console.log(this.clientPlaceCategories);
        this.accountApiService
            .setCustomDefaultPlaceCategory(this.hubName, this.clientPlaceCategories, this.editedCategories.filter(function (x) { return x.oldTitle !== x.newTitle; }))
            .finally(event.complete)
            .subscribe(function () {
            _this.alertify.successfully('Saving custom place categories');
            _this.updateLocalStorage();
            _this.sendCategoryUpdateFlow();
        });
    };
    /**
     * add a category code with the same name as category text so that user can select this category for a place
     * */
    CustomizePlaceCategoryComponent.prototype.addSameNameCategory = function (category) {
        var _this = this;
        category.isEditing = false;
        var code = PlaceService.toCategoryCode(category.title);
        if (category.categoryList.indexOf(code) < 0) {
            category.categoryList.unshift(code);
        }
        if (category.subCategories && category.subCategories.length) {
            category.subCategories.forEach(function (x) {
                x.isEditing = false;
                _this.addSameNameCategory(x);
            });
        }
    };
    CustomizePlaceCategoryComponent.prototype.loadCustomCategories = function () {
        var _this = this;
        setTimeout(function () {
            var customDefaultPlaceCategory = LocalStorageService.getCustomDefaultPlaceCategoryFromLocalStorage();
            _this.isUseDefault = customDefaultPlaceCategory.useDefault;
            _this.clientPlaceCategories = customDefaultPlaceCategory.customCategories;
            _this.mergedDefaultCategories = customDefaultPlaceCategory.mergedDefaultCategories;
            _this.blockGooglePlaceCategories = customDefaultPlaceCategory.blockGooglePlaceCategories
                ? customDefaultPlaceCategory.blockGooglePlaceCategories.split(', ')
                : [];
            _this.syncCategoryListAreaHeightWithEditorAreaHeight();
        }, 2000);
    };
    CustomizePlaceCategoryComponent.prototype.updateLocalStorage = function () {
        /** when searching places in the client dashboard sidebar, user can select to not using filters (search from all existing places)
             see getAllowedPlaceCategories in hub.calendar.component.ts
             this function will use this storage. So if the custom place category changes, clear the storage
             */
        localStorage.removeItem(localStorageKeys.allowedPlaceCategories);
        var allSettings = LocalStorageService.getAllBackendSettingsFromLocalStorage();
        if (!allSettings)
            return;
        allSettings.customSettings.customDefaultPlaceCategory.useDefault = this.isUseDefault;
        allSettings.customSettings.customDefaultPlaceCategory.customCategories = this.clientPlaceCategories;
        localStorage.setItem(localStorageKeys.allBackendSettings, JSON.stringify(allSettings));
    };
    CustomizePlaceCategoryComponent.prototype.isSelected = function (categoryTitle) {
        var selected = this.isInSelectedCategory(categoryTitle);
        return selected;
    };
    CustomizePlaceCategoryComponent.prototype.defaultCategorySelectionChange = function (checkbox) {
        var categoryCode = PlaceService.toCategoryCode(checkbox.source.name);
        if (checkbox.checked) {
            if (!this.isInSelectedCategory(categoryCode)) {
                this.selectedItem.categoryList.push(categoryCode);
            }
        }
        else {
            this.selectedItem.categoryList.splice(this.selectedItem.categoryList.indexOf(categoryCode), 1);
        }
    };
    CustomizePlaceCategoryComponent.prototype.selectCategory = function (item) {
        console.log('custom', item);
        this.selectedItem = item;
        this.syncCategoryListAreaHeightWithEditorAreaHeight();
    };
    CustomizePlaceCategoryComponent.prototype.onSubCategoryRemove = function ($event, item) {
        this.selectedItem = null;
        this.removeFirstLevel(item);
        this.syncCategoryListAreaHeightWithEditorAreaHeight();
    };
    CustomizePlaceCategoryComponent.prototype.setCategoryRemovedData = function (item) {
        /** after edited a category, need to notify the server side to update the existing places which hold this category */
        var exist = this.editedCategories.find(function (x) { return x._id === item._id; });
        if (exist) {
            exist.type = 'deleted';
            // has newTitle means this categories has been edited, should remove the newTitle so that server side can find and remove this category from the places
            exist.oldTitle = exist.newTitle;
            delete exist.newTitle;
        }
        else {
            this.editedCategories.push({
                _id: item._id,
                type: 'deleted',
                oldTitle: PlaceService.toCategoryCode(item.title),
            });
        }
    };
    CustomizePlaceCategoryComponent.prototype.onCategoryTitleEdited = function ($event) {
        /** after edited a category, need to notify the server side to update the existing places which hold this category */
        var exist = this.editedCategories.find(function (x) { return x._id === $event.item._id; });
        if (exist) {
            exist.oldTitle = PlaceService.toCategoryCode($event.oldTitle);
            exist.newTitle = PlaceService.toCategoryCode($event.newTitle);
        }
        else {
            this.editedCategories.push({
                _id: $event.item._id,
                oldTitle: PlaceService.toCategoryCode($event.oldTitle),
                newTitle: PlaceService.toCategoryCode($event.newTitle),
                type: 'edited',
            });
        }
    };
    CustomizePlaceCategoryComponent.prototype.add1stLevelCategory = function () {
        this.clientPlaceCategories.push(new PlaceType('New category', 0));
        this.syncCategoryListAreaHeightWithEditorAreaHeight();
    };
    CustomizePlaceCategoryComponent.prototype.updateCategoryTitle = function ($event) { };
    CustomizePlaceCategoryComponent.prototype.showReadable = function (code) {
        return PlaceService.toReadableCategory(code);
    };
    CustomizePlaceCategoryComponent.prototype.isInSelectedCategory = function (categoryTitle) {
        return this.selectedItem.categoryList.indexOf(categoryTitle) >= 0;
    };
    CustomizePlaceCategoryComponent.prototype.sendCategoryUpdateFlow = function () {
        this.customDefaultPlaceCategoryStore.CustomDefaultPlaceCategoryCommand.next({
            useDefault: this.isUseDefault,
            customCategories: this.clientPlaceCategories,
        });
        /** when searching places in the client dashboard sidebar, user can select to not using filters (search from all existing places)
             see getAllowedPlaceCategories in hub.calendar.component.ts
             this function will use this storage. So if the custom place category changes, clear the storage
             */
        localStorage.removeItem(localStorageKeys.allowedPlaceCategories);
    };
    return CustomizePlaceCategoryComponent;
}(BaseComponent));
export { CustomizePlaceCategoryComponent };
var PlaceType = /** @class */ (function () {
    function PlaceType(title, level) {
        this.title = title;
        this.icon = null;
        this.subCategories = [];
        this.categoryList = [];
        this.isEditing = false;
        this.id = guid();
        this.level = isNumber(level) ? level : undefined;
    }
    return PlaceType;
}());
export { PlaceType };
var EditedCategory = /** @class */ (function () {
    function EditedCategory() {
    }
    return EditedCategory;
}());
export { EditedCategory };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/place.category/customize.place.category.component.ts.pre-build-optimizer.js